import React from 'react';
import './page.css';
import MainTitle from '../../components/page/main-title/MainTitle';
import ButtonAdd from '../../components/form/ButtonAdd';
import ItemMensagem from './ItemMensagem';
import Container from '../../components/container/Container';
import Modal from '../../components/modal/Modal';
import Page from './Page';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import EmptyList from '../../components/emptyList/EmptyList';
import LoadingPage from '../../components/loading/LoadingPage';
import { Closest } from '../../utils/htmlnodes/Selectors';
import NewMessage from './NewMessage';

const URL_REMOVE_ITEM = WS.blocos.remove;
const URL_BLOCOS_LISTA = WS.mensagens.lista;
const URL_DETALHE_ITEM = WS.mensagens.detalhe;

const RECEBIDAS = 1;
const ENVIADAS = 2;

class Mensagens extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      isLoading: true,
      tipoMensagem: RECEBIDAS
    }

    this.handleClick = this.handleClick.bind(this);
    this.btEditClick = this.btEditClick.bind(this);
    this.remove = this.remove.bind(this);
    this.onRemoveItem = this.onRemoveItem.bind(this);
    this.changeTipoMensagem = this.changeTipoMensagem.bind(this);
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url:URL_BLOCOS_LISTA,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            recebidas: data.data.recebidas,
            enviadas: data.data.enviadas
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }

        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  componentWillUnmount() {

  }

  onRemoveItem (e,data){
    Dialog.destroy();
    const {
      msgRemover,
      atencao,
      fechar,
      remover,
      itemRemovidoSucesso,
      impossivelRemoverItem,
      erroRemover
    } = this.state.strings;
    //----------------
    const id = data.id;
    const item = Closest(e,'.item-listagem');

    Requisitions({
      url:URL_REMOVE_ITEM,
      data:{ id: id },
      sucess:function(data){
        var msg;
        if(data.status){
          msg = {
            title: atencao,
            text: itemRemovidoSucesso
          };

          //remove o item
          item.remove();
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
        }
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroRemover
        });
      }
    });
    //----------------
  }

  changeTipoMensagem(e,tipo) {
    this.setState({
      tipoMensagem: tipo
    });

    e.preventDefault();
  }

  remove (element) {
    const button = element.currentTarget;
    const {msgRemover,atencao,fechar,remover} = this.state.strings;
    const _self = this;
    const item = Closest(button,'.item-listagem');
    const id = item.getAttribute('data-id');

    this.checkId(id);

    Dialog.create({
      type: Dialog.CONFIRM,
      title: atencao,
      text: msgRemover,
      txtCancel: fechar,
      txtOk: remover,
      onSubmit: (el) => {
        _self.onRemoveItem(button,{id:id});
        el.preventDefault();
      }
    });
    element.preventDefault();
  }

  checkId (id){
    const {atencao,impossivelRemoverItem} = this.state.strings;
    if(!id){
      Dialog.create({
        title: atencao,
        text: impossivelRemoverItem
      });
      return false;
    }
  }

  btEditClick (e){
    const item = Closest(e.currentTarget,'.item-listagem');
    const id = item.getAttribute('data-id');
    const {atencao,erroDetalhe} = this.state.strings;

    const history = this.props.history;

    Requisitions({
      url:URL_DETALHE_ITEM,
      data:{ id },
      sucess:function(data){
        var msg;
        if(data.status){
          var modal = new Modal();
          modal.open({page:<Page modal={modal} id={id} detalhe={data.data} history={history} />});
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroDetalhe
        });
      }
    });

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  handleClick (e){
    var modal = new Modal();
    const history = this.props.history;
    modal.open({page:<NewMessage modal={modal}  history={history} />});

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  getMensagens() {
    const data = this.state.tipoMensagem === RECEBIDAS ? this.state.recebidas : this.state.enviadas ;
    let lista = data.map((value, i) =>
        <ItemMensagem data={value} key={i} onClickHandler={this.btEditClick} />
      );

    if(lista.length<=0){
      lista = <EmptyList />
    }

    return lista;
  }

  render (){
    const { titleMensagens } = this.state.strings;

    let wrapper = this.state.isLoading ? <LoadingPage /> : this.getMensagens();

    return (
      <Container>
        <MainTitle title={ titleMensagens }></MainTitle>
          {/*<div className='wrapper-buttons-mensagens'>
            <a
              onClick={(e) => this.changeTipoMensagem(e, RECEBIDAS)}
              className={`${(this.state.tipoMensagem === RECEBIDAS ? 'ativo' : '')} button-mensagem`}
              href="#"
            >Recebidas</a>
            <a
              onClick={(e) => this.changeTipoMensagem(e, ENVIADAS)}
              className={`${(this.state.tipoMensagem === ENVIADAS ? 'ativo' : '')} button-mensagem`}
              href="#"
            >Enviadas</a>
          </div>*/}
          <ButtonAdd myClick={this.handleClick}></ButtonAdd>
          <div className="listagem listagem-mensagens listagem-mensagens--wrapper">
            {wrapper}
          </div>
          <div className='clear'></div>
      </Container>
    );
  }
}

export default Mensagens;



// WEBPACK FOOTER //
// ./src/classes/mensagens/Mensagens.js